module.exports = __webpack_public_path__ + "static/media/logo2.9cce09d6.png";